import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'

@Injectable({ providedIn: 'root' })
export class NavigationService
{
  private history: string[] = [];

  constructor(private router: Router, private location: Location, private route: ActivatedRoute) 
  {
    this.router.events.subscribe((event) => 
    {
      if (event instanceof NavigationEnd) 
      {
        this.history.push(event.urlAfterRedirects);
      }
    })
  }

  back(): void 
  {
    if(this.history.length > 0)
    {
      this.history.pop();
      
      this.location.back();
    }
  }
}